import React, { FC, useEffect } from "react";
import * as NavigationActions from '../../../actions/navigation';
import RestrictedLayout from "../../../components/layouts/RestrictedLayout";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { InstitutionSettingsBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { SettingsInstitutionsSubMenu, SettingsSubMenu } from "../../../helpers/subMenuHelper";
import useDispatch, { useActionCreator } from "../../../hooks/useDispatch";
import useSelector from "../../../hooks/useSelector";
import SettingsCard from "../SettingsCard";

import './InstitutionSettingsPage.scss';

const InstitutionSettings: FC = () => {
    // Sidebar items
    const permissions = useSelector(state => state.user.userSummary?.permissions ?? []);
    const sideBarItems = SettingsSubMenu(permissions);
    
    // Breadcrumbs
    const breadcrumbs = InstitutionSettingsBreadcrumbs();

    // Menu items
    const menuItems = SettingsInstitutionsSubMenu(permissions);

    const dispatch = useDispatch();
    const setDrawerItems = useActionCreator(NavigationActions.SetDrawerItems, dispatch);
    const setBreadcrumbs = useActionCreator(NavigationActions.SetBreadcrumbs, dispatch);


    useEffect(() => {
        setDrawerItems(sideBarItems);
        setBreadcrumbs(breadcrumbs);
    }, [setDrawerItems, setBreadcrumbs]);

    const renderInstitutionSettingsCards = () => {
        return menuItems?.filter(x => x.description)?.map((item, index) => (
            <SettingsCard 
                key={`item-${item.title}-${index}`}
                navItem={item}
            />
        ));
    }

    return (
        <RestrictedLayout
            permission={Dtos.Permission.InstitutionSettingsView}
        >
            <div className="settings-page">
                <div className="settings-container">
                    <h1 className="mb-4">Institution</h1>
                    <div className="settings-grid">
                        {renderInstitutionSettingsCards()}
                    </div>
                </div>
            </div>
        </RestrictedLayout>
    );
}

export default InstitutionSettings;